import { render, staticRenderFns } from "./CommunicationDialog.vue?vue&type=template&id=4107a418&scoped=true&"
import script from "./CommunicationDialog.vue?vue&type=script&lang=js&"
export * from "./CommunicationDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationDialog.vue?vue&type=style&index=0&id=4107a418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4107a418",
  null
  
)

export default component.exports